import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

/***
Informations légales,Link,/informations-legales
Plan du site,Link,/page/site-map
*/

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
        icon: 'navigation-link__home',
    },
    {
        type: 'link',
        label: 'navigation.assignment_learner',
        link: '/followed/tab/list',
        icon: 'navigation-link__assignments',
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                icon: 'navigation-group__corpus',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                        icon: 'navigation-link__global-corpus',
                    },
                    {
                        type: 'link',
                        label: 'navigation.corpus_user',
                        link: '{{USER_CORPUS_LINK}}',
                        icon: 'navigation-link__user-corpus',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.notepad',
                link: '/notepad/list',
                icon: 'navigation-link__notepad',
            },
            {
                type: 'link',
                label: 'navigation.mindmap',
                link: '/mindmap/list',
                icon: 'navigation-link__mindmap',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '{{SITE_MAP_LINK}}',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
